import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_MEDIA_AVAILABILITIES)(actionTypes.MEDIA_AVAILABILITIES_RESPONSE);

const mediaAvailabilitiesReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.MEDIA_AVAILABILITIES_RESPONSE:
            return action.payload.mediaAvailabilities;
        default: return state;
    }
};

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    mediaAvailabilities: mediaAvailabilitiesReducer,
});

export default reducer;